import React, { 
  forwardRef, 
  useEffect, 
  useState
} from 'react';
import classNames from 'classnames';
import { CONTAINER_PROPS } from './Types';
import { getWindowDimensions } from '../../../utility/Util';

const Container = forwardRef((props: CONTAINER_PROPS, ref: any) => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    // cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const {
    style,
    scope,
    ariaHidden,
    ariaLabeledBy,
    ariaLabel,
    ariaSelected,
    ariaChecked,
    role,
    tabIndex,
    cmpKey,
    responsive,
    htmlTag,
    id,
    className,
    children,
    displayFlex,
    displayInlineFlex,
    hBox,
    vBox,
    flexDirectionRow,
    flexDirectionRowReverse,
    flexDirectionColumn,
    flexDirectionColumnReverse,
    wrap,
    noWrap,
    wrapReverse,
    flexInitial,
    flex1,
    flexAuto,
    flexNone,
    flexGrow,
    flexGrow0,
    flexShrink,
    flexShrink0,
    flexBasisAuto,
    flexBasis0,
    alignItemsStart,
    alignItemsEnd,
    alignItemsCenter,
    alignItemsStretch,
    alignItemsBaseLine,
    justifyContentStart,
    justifyContentEnd,
    justifyContentCenter,
    justifyContentBetween,
    justifyContentAround,
    justifyContentEvenly,
    onContextMenu,
    gap,
    paddingZero,
    paddingAll,
    paddingRight,
    paddingLeft,
    paddingY,
    paddingTop,
    paddingBottom,
    paddingX,
    dataCy,
    onClick,
    onDoubleClick,
    onKeyDown,
    onKeyUp
  } = props;

  const containerClasses = classNames(
    className,
    {
      'k-d-flex-row': hBox,
      'k-d-flex-col': vBox,
      'k-d-flex': displayFlex,
      'k-d-inline-flex': displayInlineFlex,
      'k-flex-row': flexDirectionRow,
      'k-flex-row-reverse': flexDirectionRowReverse,
      'k-flex-col': flexDirectionColumn,
      'k-flex-col-reverse': flexDirectionColumnReverse,
      'k-flex-wrap': wrap,
      'k-flex-nowrap': noWrap,
      'k-flex-wrap-reverse': wrapReverse,
      'k-flex-initial': flexInitial,
      'k-flex-1': flex1,
      'k-flex-auto': flexAuto,
      'k-flex-none': flexNone,
      'k-flex-grow': flexGrow,
      'k-flex-grow-0': flexGrow0,
      'k-flex-shrink': flexShrink,
      'k-flex-shrink-0': flexShrink0,
      'k-flex-basis-auto': flexBasisAuto,
      'k-flex-basis-0': flexBasis0,
      'k-align-items-start': alignItemsStart,
      'k-align-items-end': alignItemsEnd,
      'k-align-items-center': alignItemsCenter,
      'k-align-items-stretch': alignItemsStretch,
      'k-align-items-baseline': alignItemsBaseLine,
      'k-justify-content-start': justifyContentStart,
      'k-justify-content-end': justifyContentEnd,
      'k-justify-content-center': justifyContentCenter,
      'k-justify-content-between': justifyContentBetween,
      'k-justify-content-around': justifyContentAround,
      'k-justify-content-evenly': justifyContentEvenly,
      'k-p-0': paddingZero,
      'k-p-6': paddingAll,
      'k-pr-6': paddingRight,
      'k-pl-6': paddingLeft,
      'k-py-6': paddingY,
      'k-pt-6': paddingTop,
      'k-pb-6': paddingBottom,
      'k-px-6': paddingX,
      'tp-gap-1': gap == 1,
      'tp-gap-2': gap == 2,
      'tp-gap-3': gap == 3,
      'tp-gap-4': gap == 4,
      'tp-gap-5': gap == 5,
      'tp-gap-6': gap == 6,
      'tp-form-gap': gap == 'form',
      [responsive && responsive.xxlg]: responsive && responsive.xxlg && windowDimensions.width < 1520,
      [responsive && responsive.xlg]: responsive && responsive.xlg && windowDimensions.width < 1367,
      [responsive && responsive.lg]: responsive && responsive.lg && windowDimensions.width < 1200,
      [responsive && responsive.lmd]: responsive && responsive.lmd && windowDimensions.width < 1025,
      [responsive && responsive.md]: responsive && responsive.md && windowDimensions.width < 992,
      [responsive && responsive.m]: responsive && responsive.m && windowDimensions.width < 870,
      [responsive && responsive.sm]: responsive && responsive.sm && windowDimensions.width < 768,
      [responsive && responsive.xs]: responsive && responsive.xs && windowDimensions.width < 576
    }
  );

  return (
    React.createElement(
      `${htmlTag ? htmlTag : 'div'}`,
      {
        style: style,
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        'scope': scope,
        'aria-hidden': ariaHidden,
        'aria-selected': ariaSelected,
        'aria-checked': ariaChecked,
        tabIndex: tabIndex,
        key: cmpKey,
        ref: ref,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabeledBy,
        className: containerClasses,
        id: id,
        'role': role,
        onContextMenu,
        'data-cy': dataCy,
        'data-preventrecorddeselect': props['data-preventrecorddeselect']
      },
      [children]
    )
  );
});

export default Container;
